import React from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import CardIcon from "../../../../../Utilities/CardIcon";

import { formatDate } from "../../../../../Helpers/formatters";

const CustomerOrderTransactionTab = ({ row }) => {

  return (
    <Table size="small" aria-label="purchases">
      <TableHead>
        <TableRow>
          <TableCell align="center" className="mid">
            MID
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Product ID
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Transaction Date
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Auth Code
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Message
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Transaction Type
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Reference ID
          </TableCell>
          <TableCell align="center"></TableCell>
          <TableCell align="center"></TableCell>
          <TableCell className="order-widget-heading" align="center">
            Gateway MID
          </TableCell>
          <TableCell className="order-widget-heading" align="center">
            Cardholder Authorization
          </TableCell>
          <TableCell className="order-widget-heading" align="center">
            Payment Token Type
          </TableCell>
          <TableCell className="order-widget-heading" align="center" colSpan={2}>
            Card details
          </TableCell>
          <TableCell align="center"></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {row.transactionDetails !== "" ? (
          row.transactionDetails.map((transactionData, idx) => (
            <TableRow key={transactionData.orderNumber+"-"+idx}>
              <TableCell className="data-to-show" align="center">
                {transactionData.mid ? transactionData.mid : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.productId ? transactionData.productId : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.transactionDate
                  ? formatDate(transactionData.transactionDate)
                  : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.authCode ? transactionData.authCode : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.message ? transactionData.message : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.transactionType
                  ? transactionData.transactionType
                  : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.referenceId
                  ? transactionData.referenceId
                  : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.gatewayMid
                  ? transactionData.gatewayMid
                  : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.cardholderAuth ? transactionData.cardholderAuth : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.paymentTokenType ? transactionData.paymentTokenType : "n/a"}
              </TableCell>
              <TableCell className="data-to-show" align="center">
                  { transactionData.cardType ? <CardIcon cardType={transactionData.cardType} /> : "n/a" }
              </TableCell>
              <TableCell className="data-to-show" align="center">
                {transactionData.cardType && transactionData.lastFour ? transactionData.lastFour  : ""}
              </TableCell>
              <TableCell className="data-to-show" align="center">
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow className="nothing-to-show">
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
            <TableCell className="nothing-to-show">n/a</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default CustomerOrderTransactionTab;
